import { render, staticRenderFns } from "./DeletedEntitiesV4.vue?vue&type=template&id=a464d8a6&scoped=true"
import script from "./DeletedEntitiesV4.vue?vue&type=script&lang=js"
export * from "./DeletedEntitiesV4.vue?vue&type=script&lang=js"
import style0 from "./DeletedEntitiesV4.vue?vue&type=style&index=0&id=a464d8a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a464d8a6",
  null
  
)

export default component.exports